export const makeBeatportUrl = (item) => {
  switch (item.type) {
    case 'track':
      return `${BEATPORT_APP_BASE}/track/${item.slug}/${item.id}`
    default:
      return BEATPORT_APP_BASE;
  }
}
